import { useEffect, useRef, useState } from 'react';

import { useBoundStore } from 'app/store';
import { OneBtnFooter } from 'widgets/HsptlzForm/ui';

import { useUserFormContext } from '../model';
import { useSubmitUserForm } from '../model/mutation';

import { EditForm } from './EditForm';
import Field from './Field';
import { Title } from './Title';
import './userForm.css';

export const EditFormContainer = ({
  patientInfoData: {
    usrNm,
    usrBirthday,
    msgRcvTelMaxNum,
    postNo,
    bscAddr,
    dtlAddr,
    actualPostNo,
    actualBscAddr,
    actualDtlAddr,
    custCtrTelNo,
    redirectUrl,
  },
}) => {
  const { hspId, usrId, hsptlzRsvNo } = useBoundStore((state) => state['hsptlzForm'].serviceParams);
  const { submit } = useSubmitUserForm();
  const { addressData, invalidFields } = useUserFormContext();
  const [isValid, setIsValid] = useState(false);
  const firstSubmitForm = useBoundStore((state) => state.hsptlzForm.firstSubmitForm);
  const setFirstSubmitForm = useBoundStore((state) => state.hsptlzForm.setFirstSubmitForm);
  const phoneInputRefs = useRef([]);
  const phoneInputDataRef = useRef(null);

  const handleSubmit = () => {
    if (!checkValidFields()) {
      setFirstSubmitForm(false);
      return;
    }
    const actualAddr = addressData.actualAddr.isSameAddr ? addressData.addr : addressData.actualAddr;
    const updatedAddr =
      postNo !== addressData.addr.postNo ||
      bscAddr !== addressData.addr.bscAddr ||
      dtlAddr !== addressData.addr.dtlAddr;

    submit({
      hspId,
      usrId,
      hsptlzRsvNo,
      usrTelNo: phoneInputDataRef.current,
      addrUdpYn: updatedAddr ? 'Y' : 'N', // 주소 업데이트 여부
      postNo: addressData.addr.postNo,
      bscAddr: addressData.addr.bscAddr,
      dtlAddr: addressData.addr.dtlAddr,
      bldgCd: addressData.addr.bldgCd, // 건물 번호
      actualPostNo: actualAddr.postNo, // 실 거주지
      actualBscAddr: actualAddr.bscAddr,
      actualDtlAddr: actualAddr.dtlAddr,
      actualBldgCd: '', // 실 거주 건물 번호
    });
  };
  const checkValidFields = () => {
    return Object.values(invalidFields).every((target) => {
      if (Array.isArray(target)) {
        return target.every((value) => value !== undefined && !value);
      }
      return target !== undefined && !target;
    });
  };
  // 유효성 검증
  useEffect(() => {
    // const actualAddr = addressData.actualAddr.isSameAddr ? addressData.addr : addressData.actualAddr;
    const validPhone = phoneInputRefs.current.every((ref) => ref?.value !== '');

    const isValidData = validPhone && addressData.addr.postNo && addressData.addr.bscAddr && addressData.addr.dtlAddr;
    // 추후 반영 (실 주소)
    // actualAddr.postNo &&
    // actualAddr.bscAddr &&
    // actualAddr.dtlAddr;

    const checkValid = !firstSubmitForm ? checkValidFields() : true;
    // 추후에 address 부분도 에러메시지가 추가 된다면, invalidFields 에 추가 되어야 함
    if (checkValid && isValidData) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [invalidFields, addressData, firstSubmitForm]);

  return (
    <EditForm>
      <Title>
        <Title.Main />
        <Title.Sub />
      </Title>
      <Field>
        <Field.NameAndBirth usrNm={usrNm} usrBirthday={usrBirthday} />
        <Field.TelContainer
          phoneInputDataRef={phoneInputDataRef}
          msgRcvTelMaxNum={msgRcvTelMaxNum}
          ref={phoneInputRefs}
        />
        <Field.AddressContainer />
      </Field>
      <OneBtnFooter text={'저장 후 다음'} handleClick={handleSubmit} disabled={!isValid} isValid={isValid} />
    </EditForm>
  );
};
